export const stylesRefs = {
  kanbanCardStyle: 'Kanban_kanbanCardStyle',
}
